'use client';

import { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import NextImage from 'next/image';
declare global {
  interface Window {
    HubSpotConversations?: {
      widget: {
        open: () => void;
        close: () => void;
        refresh: () => void;
      };
    };
  }
}
const CHAT_BUTTON_SIZE = 60;
const CHAT_BUTTON_SIZE_MOBILE = 56;
const HUBSPOT_CHECK_INTERVAL_MS = 100;
const HUBSPOT_WIDGET_LOAD_DELAY_MS = 2000;
export default function HubSpotChatButton() {
  const [isHubSpotReady, setIsHubSpotReady] = useState(false);
  useEffect(() => {
    const checkHubSpotWidget = setInterval(() => {
      if (typeof window.HubSpotConversations?.widget?.open === 'function') {
        setIsHubSpotReady(true);
        clearInterval(checkHubSpotWidget);
      }
    }, HUBSPOT_CHECK_INTERVAL_MS);

    // Fallback: If HubSpot API exists but widget not immediately ready, wait a bit longer
    const fallbackCheck = setTimeout(() => {
      if (window.HubSpotConversations && !isHubSpotReady) {
        if (typeof window.HubSpotConversations.widget?.open === 'function') {
          setIsHubSpotReady(true);
        }
      }
    }, HUBSPOT_WIDGET_LOAD_DELAY_MS);
    return () => {
      clearInterval(checkHubSpotWidget);
      clearTimeout(fallbackCheck);
    };
  }, [isHubSpotReady]);
  const handleOpenChat = () => {
    window.HubSpotConversations?.widget.open();
  };
  if (!isHubSpotReady) {
    return null;
  }
  return <Box as="button" position="fixed" bottom={{
    base: '77px',
    tablet: '20px'
  }} right="20px" width={{
    base: `${CHAT_BUTTON_SIZE_MOBILE}px`,
    tablet: `${CHAT_BUTTON_SIZE}px`
  }} height={{
    base: `${CHAT_BUTTON_SIZE_MOBILE}px`,
    tablet: `${CHAT_BUTTON_SIZE}px`
  }} borderRadius="50%" boxShadow="0 4px 12px rgba(0, 0, 0, 0.15)" cursor="pointer" zIndex={9999} transition="transform 0.2s ease" _hover={{
    transform: 'scale(1.1)'
  }} onClick={handleOpenChat} aria-label="Open chat" border="none" padding="0" backgroundColor="transparent" overflow="hidden" data-sentry-element="Box" data-sentry-component="HubSpotChatButton" data-sentry-source-file="HubSpotChatButton.tsx">
      <Box display={{
      base: 'block',
      tablet: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="HubSpotChatButton.tsx">
        <NextImage src="/chatbot.png" alt="Chat with us" width={CHAT_BUTTON_SIZE_MOBILE} height={CHAT_BUTTON_SIZE_MOBILE} priority data-sentry-element="NextImage" data-sentry-source-file="HubSpotChatButton.tsx" />
      </Box>
      <Box display={{
      base: 'none',
      tablet: 'block'
    }} data-sentry-element="Box" data-sentry-source-file="HubSpotChatButton.tsx">
        <NextImage src="/chatbot.png" alt="Chat with us" width={CHAT_BUTTON_SIZE} height={CHAT_BUTTON_SIZE} priority data-sentry-element="NextImage" data-sentry-source-file="HubSpotChatButton.tsx" />
      </Box>
    </Box>;
}